<template>
  <div class="sidebar">
    <router-link
      v-if="permissions.includes('viewAny organization')"
      @click="checkDataHandler($event, 'organizations')"
      :to="setDataFlag ? '#' : '/organizations'"
      :class="{ active: activeTap === 'organizations' }"
      class="nav-link"
    >
      <!--            <img src="../../assets/images/organization.png" width="20" alt="">-->

      <div class="link-container gap-3 sidebar-icon">
        <span class="">
          <font-awesome-icon
            class=""
            :icon="['fas', 'people-group']"
            size="sm"
          />
        </span>
        <span class="d-none d-sm-inline" style="font-size: 15px"
          >Organizations</span
        >
      </div>
    </router-link>
    <router-link
      v-if="role === 'super_admin'"
      @click="checkDataHandler($event, 'roles')"
      :to="setDataFlag ? '#' : '/roles'"
      :class="{ active: activeTap === 'roles' }"
      class="nav-link"
    >
      <div class="link-container gap-3 sidebar-icon">
        <span class="">
          <font-awesome-icon class="" :icon="['fas', 'toggle-off']" size="sm" />
        </span>
        <span class="d-none d-sm-inline" style="font-size: 15px">Roles</span>
      </div>
    </router-link>
    <router-link
      v-if="role === 'super_admin'"
      @click="checkDataHandler($event, 'super/users')"
      :to="setDataFlag ? '#' : '/super/users'"
      :class="{ active: activeTap === 'super-users' }"
      class="nav-link"
    >
      <div class="link-container gap-3 sidebar-icon">
        <span class="">
          <font-awesome-icon class="" :icon="['fas', 'gear']" size="sm" />
        </span>
        <span class="d-none d-sm-inline" style="font-size: 15px">Users</span>
      </div>
    </router-link>
    <router-link
      v-if="permissions.includes('viewAny template')"
      @click="checkDataHandler($event, 'templates')"
      :to="setDataFlag ? '#' : '/templates'"
      :class="{ active: activeTap === 'templates' }"
      class="nav-link"
    >
      <!--            <img src="../../assets/images/templateImage.png" width="20" alt=""> <span-->
      <!--                class="ms-1 d-none d-sm-inline" style="font-size:15px">Templates</span>-->

      <div class="link-container gap-3 sidebar-icon">
        <span class="">
          <font-awesome-icon class="" :icon="['fas', 'list']" size="sm" />
        </span>
        <span class="d-none d-sm-inline" style="font-size: 15px"
          >Templates</span
        >
      </div>
    </router-link>

    <router-link
      v-if="permissions.includes('viewAny competition') && role !== 'user'"
      @click="checkDataHandler($event, 'competitions')"
      :to="setDataFlag || setAnswersFlag ? '#' : '/competitions'"
      :class="{ active: activeTap === 'competition' }"
      class="nav-link"
    >
      <!--            <img src="../../assets/images/trophy.png" width="20" alt=""> <span class="ms-1 d-none d-sm-inline"-->
      <!--                                                                               style="font-size:15px">Competitions</span>-->

      <div class="link-container gap-3 sidebar-icon">
        <span class="">
          <font-awesome-icon class="" :icon="['fas', 'trophy']" size="sm" />
        </span>
        <span class="d-none d-sm-inline" style="font-size: 15px"
          >Competitions</span
        >
      </div>
    </router-link>

    <router-link
      v-else-if="permissions.includes('viewAny competition') && role === 'user'"
      @click="checkDataHandler($event, 'user-competitions')"
      :to="setDataFlag || setAnswersFlag ? '#' : '/user-competitions'"
      :class="{ active: activeTap === 'competition' }"
      class="nav-link"
    >
      <div class="d-flex gap-3 sidebar-icon">
        <span class="">
          <font-awesome-icon class="" :icon="['fas', 'trophy']" size="sm" />
        </span>
        <span class="d-none d-sm-inline" style="font-size: 15px"
          >Competitions</span
        >
      </div>
    </router-link>

    <div v-else></div>

    <router-link
      v-if="permissions.includes('viewAny training') && role !== 'user'"
      @click="checkDataHandler($event, 'trainings')"
      :to="setDataFlag || setAnswersFlag ? '#' : '/trainings'"
      :class="{ active: activeTap === 'training' }"
      class="nav-link"
    >
      <!--            <img src="../../assets/images/training.png" width="20" alt=""> <span class="ms-1 d-none d-sm-inline"-->
      <!--                                                                                 style="font-size:15px">Training</span>-->

      <div class="link-container gap-3 sidebar-icon">
        <span class="">
          <font-awesome-icon class="" :icon="['fas', 'brain']" size="sm" />
        </span>
        <span class="d-none d-sm-inline" style="font-size: 15px"
          >Trainings</span
        >
      </div>
    </router-link>

    <router-link
      v-else-if="permissions.includes('viewAny training') && role === 'user'"
      @click="checkDataHandler($event, 'user-trainings')"
      :to="setDataFlag || setAnswersFlag ? '#' : '/user-trainings'"
      :class="{ active: activeTap === 'training' }"
      class="nav-link"
    >
      <div class="link-container gap-3 sidebar-icon">
        <span class="">
          <font-awesome-icon class="" :icon="['fas', 'brain']" size="sm" />
        </span>
        <span class="d-none d-sm-inline" style="font-size: 15px"
          >Trainings</span
        >
      </div>
    </router-link>

    <div v-else></div>

    <router-link
      v-if="permissions.includes('viewAny userscore')"
      @click="checkDataHandler($event, 'results')"
      :to="setDataFlag ? '#' : '/results'"
      :class="{ active: activeTap === 'results' }"
      class="nav-link"
    >
      <!--            <img src="../../assets/images/results.png" width="20" alt=""> <span class="ms-1 d-none d-sm-inline"-->
      <!--                                                                                style="font-size:15px">Results</span>-->

      <div class="link-container gap-3 sidebar-icon">
        <span class="">
          <font-awesome-icon
            class=""
            :icon="['fas', 'clipboard-list']"
            size="sm"
          />
        </span>
        <span class="d-none d-sm-inline" style="font-size: 15px">Results</span>
      </div>
    </router-link>

    <router-link
      v-if="permissions.includes('viewAny score')"
      @click="checkDataHandler($event, 'results')"
      :to="setDataFlag ? '#' : '/user-score'"
      :class="{ active: activeTap === 'score' }"
      class="nav-link"
    >
      <!--            <img src="../../assets/images/results.png" width="20" alt=""> <span class="ms-1 d-none d-sm-inline"-->
      <!--                                                                                style="font-size:15px">Score</span>-->

      <div class="link-container gap-3 sidebar-icon">
        <span class="">
          <font-awesome-icon
            class=""
            :icon="['fas', 'clipboard-list']"
            size="sm"
          />
        </span>
        <span class="d-none d-sm-inline" style="font-size: 15px">Scores</span>
      </div>
    </router-link>

    <router-link
      v-if="permissions.includes('viewAny setting')"
      @click="checkDataHandler($event, 'settings/user')"
      :to="setDataFlag ? '#' : '/settings/roles'"
      :class="{ active: activeTap === 'settings' }"
      class="nav-link"
    >
      <!--            <img src="../../assets/images/settings.png" width="20" alt="">-->
      <!--            <span class="ms-1 d-none d-sm-inline"-->
      <!--                                                                                 style="font-size:15px">Settings</span>-->

      <div class="link-container gap-3 sidebar-icon">
        <span class="">
          <font-awesome-icon class="" :icon="['fas', 'gear']" size="sm" />
        </span>
        <span class="d-none d-sm-inline" style="font-size: 15px">Settings</span>
      </div>
    </router-link>

    <router-link
      v-if="permissions.includes('viewAny entity')"
      @click="checkDataHandler($event, 'settings/entities')"
      :to="setDataFlag ? '#' : '/settings/entities'"
      :class="{ active: activeTap === 'settings-entities' }"
      class="nav-link"
    >
      <!--            <img src="../../assets/images/playlist_add_black.svg" width="20" alt=""> <span-->
      <!--                class="ms-1 d-none d-sm-inline" style="font-size:15px">Entities</span>-->

      <div class="link-container gap-3 sidebar-icon">
        <span class="">
          <font-awesome-icon class="" :icon="['fas', 'bars']" size="sm" />
        </span>
        <span class="d-none d-sm-inline" style="font-size: 15px">Entities</span>
      </div>
    </router-link>
    <a v-if="role === 'admin'" :href="reportsUrl" class="nav-link">
      <div class="link-container gap-2 sidebar-icon">
        <span class="">
          <svg
            stroke="currentColor"
            fill="none"
            stroke-width="2"
            viewBox="0 0 24 24"
            stroke-linecap="round"
            stroke-linejoin="round"
            xmlns="http://www.w3.org/2000/svg"
            height="20"
            width="20"
          >
            <path
              d="M9 5h-2a2 2 0 0 0 -2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2 -2v-12a2 2 0 0 0 -2 -2h-2"
            ></path>
            <path
              d="M9 3m0 2a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v0a2 2 0 0 1 -2 2h-2a2 2 0 0 1 -2 -2z"
            ></path>
            <path d="M9 17v-5"></path>
            <path d="M12 17v-1"></path>
            <path d="M15 17v-3"></path>
          </svg>
        </span>
        <span class="d-none d-sm-inline" style="font-size: 15px">Reports</span>
      </div>
    </a>
    <div class="storage_wrapper" v-if="role === 'admin'">
      <div class="d-flex justify-content-between align-items-center">
        <span class="d-none d-sm-inline storage">Storage</span>
        <span class="d-none d-sm-inline storage_value">
          {{ this.storage }}%</span
        >
      </div>
      <div class="shell">
        <div class="bar" :style="{ width: this.storage + '%',background:this.background }"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { computed, getCurrentInstance } from "vue";
import { mapGetters } from "vuex";
import repository from "../../api-services/repository";
export default {
  name: "sidebar-vue",
  data() {
    return {
      permissions: [],
      role: "",
      isActive: false,
      setDataFlag: computed(() => this.$store.state.settings.setDataFlag),
      setAnswersFlag: computed(() => this.$store.state.settings.setAnswersFlag),
      active: computed(() => this.$store.state.settings.activeTap),
      lightMode: null,
      background:'#2DC937',
      storage: 0,
      reportsUrl: computed(
        () =>
          `${process.env.VUE_APP_REPORTS_URL}?secret=${
            JSON.parse(sessionStorage.getItem("user")).token
          }&&theme=${this.$store.state.settings.isLightMood ? "light" : "dark"}`
      ),
    };
  },
  async mounted() {
    this.lightMood = this.$store.state.settings.isLightMood;
    let urlNow = this.$router.currentRoute.value;
    let substring = "view-trainings";

    this.permissions = this.$store.state.auth.permissions;
    this.role = this.$store.state.auth.user.data.role[0];

    let urlSplit = this.$router.currentRoute.value;
    if (
      urlSplit.fullPath === "/settings/teams" ||
      urlSplit.fullPath === "/settings/user"
    ) {
      this.isActive = true;
    } else if (urlNow.fullPath.includes(substring)) {
      this.isActive = true;
    } else {
      this.isActive = false;
    }

    if (this.permissions.includes("viewAny template")) {
      try {
        let resData = await repository.getAvailableStorage();
        if(resData.data.percentage > 90){ this.background = "#CC3232"}
        else if(resData.data.percentage <= 90 && resData.data.percentage > 70){this.background="#DB7B2B"}
        this.storage = resData?.data?.percentage;
      } catch (error) {
        console.log("error", error);
      }
    }
  },

  methods: {
    async checkDataHandler(e, currentRoute) {
      let setDataFlag = this.$store.state.settings.setDataFlag;
      let setAnswersFlag = this.$store.state.settings.setAnswersFlag;
      if (process.env.VUE_ENV === "development")
        console.log({ setAnswersFlag });
      await this.$store.dispatch("currentRoute", currentRoute);
      if (setAnswersFlag) {
        await this.$store.dispatch("setConfirmModal", true);
        await this.$store.dispatch(
          "setConfirmMessage",
          "Are you sure you want to exit and save all answers?"
        );
      } else if (setDataFlag) {
        if (process.env.VUE_ENV === "development") console.log("error");
        await this.$store.dispatch("setConfirmModal", true);
        await this.$store.dispatch(
          "setConfirmMessage",
          "Are you sure you want to go back and remove all data?"
        );
      } else {
        if (process.env.VUE_ENV === "development") console.log("ok");
        await this.$store.dispatch("setDataFlag", false);
        await this.$store.dispatch("setConfirmModal", false);
      }
    },
  },
  computed: {
    ...mapGetters(["activeTap"]),
  },
  watch: {
    activeTap(newValue, oldValue) {
      return newValue;
    },
  },
};
</script>

<style scoped>
.storage_wrapper {
  margin: 1em auto 0;
}
.storage_wrapper > div {
  width: 90%;
}
.storage {
  font-weight: 600;
  padding-left: 5%;
}
.storage_value {
  font-weight: 400;
  font-size: 14px;
}
.shell {
  height: 10px;
  width: 90%;
  margin: 0.3em auto;
  border: 1px solid #aaa;
  border-radius: 13px;
}

.bar {
  background: var(--btn-bg-color);
  height: 8px;
  width: 15px;
  border-radius: 9px;
}
.bar span {
  float: right;
  padding: 4px 5px;
  color: #fff;
  font-size: 0.7em;
}

.link-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.sidebar-icon {
  font-weight: 600;
  font-size: 18px;
  /*color: var(--link-icon-color);*/
}
.sidebar {
  width: 190px !important;
  margin: 0;
  padding: 0 !important;
  background-color: transparent;
  height: 76.25%;
  overflow: auto;
  border: 1px solid var(--border-input-color-search);
  border-radius: 0 8px 8px 8px;
}

.sidebar a {
  display: flex;
  color: var(--link-text-color-active);
  padding: 16px;
  text-decoration: none;
  border-bottom: 1px solid var(--border-color-specific-sidebar);
  border-top: 1px solid var(--border-color-specific-sidebar);
}

.sidebar a.active {
  background-color: var(--link-active-color);
  color: var(--link-text-color);
  border-right: 4px solid var(--link-active-border-color);
}

.sidebar a:hover:not(.active) {
  background-color: var(--link-active-color);
  color: var(--link-text-color);
  border-right: 4px solid var(--link-active-border-color);
}
</style>